// extracted by mini-css-extract-plugin
module.exports = {"related":"related-jargon_related__qwv28","link":"related-jargon_link__C6gmB","button":"related-jargon_button__DOHyo"};